import { Dispatch, SetStateAction, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { TTabOption, TTrackUrlParam } from './tabs.types';

type Props = {
  tabs: TTabOption[];
  trackUrlParam?: TTrackUrlParam;
  setActiveIndex: Dispatch<SetStateAction<number>>;
};

const useTrackQuerySearch = ({ tabs, trackUrlParam, setActiveIndex }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (!tabs?.length) return;
    if (trackUrlParam?.type === 'query') {
      const urlSearchParams = new URLSearchParams(searchParams);
      const key = trackUrlParam.key;
      const tab = urlSearchParams.get(key);
      if (!tab) return;

      const index = tabs.findIndex(({ value }) => value === tab);
      if (index === -1) {
        setActiveIndex(0);
        const urlSearchParams = new URLSearchParams(searchParams);
        urlSearchParams.set(key, tabs[0].value);
        setSearchParams(urlSearchParams);
        return;
      }

      setActiveIndex(index);
    }
  }, [searchParams, setActiveIndex, setSearchParams, tabs, trackUrlParam]);
};

export default useTrackQuerySearch;
